import { useMutation, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { EditLeagueMatch, EnterLeagueResult, ResolveLeagueMatch } from "../../../types";
import { queryKeys } from "../../query-keys";

// All four staff actions change standings/ratings for the league, so they
// invalidate everything under `leagues` rather than one query.
export function useUpholdLeagueMatch() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			leagueId,
			matchId,
			data,
		}: {
			leagueId: string;
			matchId: string;
			data?: ResolveLeagueMatch;
		}) => clubApi.leagues.matches.uphold(leagueId, matchId, data),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}

export function useVoidLeagueMatch() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			leagueId,
			matchId,
			data,
		}: {
			leagueId: string;
			matchId: string;
			data?: ResolveLeagueMatch;
		}) => clubApi.leagues.matches.void(leagueId, matchId, data),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}

export function useEditLeagueMatch() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			leagueId,
			matchId,
			data,
		}: {
			leagueId: string;
			matchId: string;
			data: EditLeagueMatch;
		}) => clubApi.leagues.matches.edit(leagueId, matchId, data),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}

export function useEnterLeagueResult() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ leagueId, data }: { leagueId: string; data: EnterLeagueResult }) =>
			clubApi.leagues.matches.enterResult(leagueId, data),
		onSuccess: () => qc.invalidateQueries({ queryKey: queryKeys.leagues.all }),
	});
}
